import string from "../../../utils/string";

export const columns =  [
  {
    Header: "Descrição",
    getValue: (data) => string.capitalize(data?.descricao),
    field: "descricao",
  },

  {
    Header: "Código",
    getValue: (data) => data?.codigo,
  },
  {
    Header: "Acondicionamento",
    getValue: (data) => data?.acondicionamento,
    key: "phone",
  },
  {
    Header: "Prazo",
    getValue: (data) => data?.prazo,
  },
  {
    Header: "Quantidade amostras",
    getValue: (data) => data?.quantidadeAmostras,
  },
  {
    Header: "Volume mínimo",
    getValue: (data) => data?.volumeMinimo,
  },
];
